var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DialogLayout", {
    attrs: {
      title: "新規追加",
      visible: _vm.dialogVisible,
      "destroy-on-close": true,
      width: "65em"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      open: _vm.open
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function() {
          return [
            _c("AirportMasterForm", {
              ref: "airportForm",
              attrs: {
                "label-width": "10em",
                formMode: "register",
                "autocomplete-airport-code-set": _vm.autocompleteAirportCodeSet,
                "autocomplete-airport-name-set": _vm.autocompleteAirportNameSet
              },
              model: {
                value: _vm.airportFormModel,
                callback: function($$v) {
                  _vm.airportFormModel = $$v
                },
                expression: "airportFormModel"
              }
            })
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c("RegisterDialogFooter", {
              on: { clear: _vm.clickClear, register: _vm.clickRegister }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }